import React from 'react';

interface RadioButtonProps {
  data: { id: number; value: string }[];
  selected: string;
  onSelect: (value: string) => void;
}

const RadioButton: React.FC<RadioButtonProps> = ({ data, selected, onSelect }) => {
  return (
    <div className="flex flex-col gap-3">
      {data.map((item) => (
        <label
          key={item.id}
          className="flex justify-between items-center w-full gap-3 p-4 rounded-2xl border-2 cursor-pointer transition-all bg-white text-black border-gray-400 hover:shadow-lg"
        >
          <span>{item.value}</span>
          <input
            type="radio"
            name="poll"
            value={item.value}
            checked={selected === item.value}
            onChange={() => onSelect(item.value)}
            className="accent-purple-700 w-5 h-5"
          />
        </label>
      ))}
    </div>

  );
};

export default RadioButton;
